import $ from 'jquery';
import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import {
  formatBid,
  getFieldValueFromGridData,
} from '@bingads-webui-campaign/recommendation-core';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import { ProductGroupsEditBidsView } from '@bingads-webui-campaign/product-group';
import decimalFormatter from '@bingads-webui-component-legacy/humanize/decimal';
import { ProductGroup } from '@bingads-webui-campaign/campaign-ui-schemas';

import { isSuggestedBidSupported } from '../const';
import template from './suggested-bid-product-group-column.pug';

class CustomizedProductGroupsEditBidsView extends ProductGroupsEditBidsView {
  initialize({
    view,
    deps,
    BidAmount,
    IsExcluded = false,
    selectedItems = [],
    IsAutoBidding,
    key,
  } = {}) {
    this.key = key;
    super.initialize({
      view,
      deps,
      BidAmount,
      IsExcluded,
      selectedItems,
      IsAutoBidding,
    });
  }

  save() {
    if (!this.validate()) {
      return;
    }
    const { view, key } = this;
    const recommendation = view.grid.gridView.itemWithKey(key);

    if (!_.isNull(recommendation)) {
      if (this.viewModel.Amount.isValid()) {
        _.first(recommendation.Opportunities).NewProductGroupBid = this.viewModel.Amount();
      }
      // Append the current selected one into existing selected ones.
      const selectedKeys = view.grid.gridView.selectedKeys();
      if (!_.contains(selectedKeys, key)) {
        selectedKeys.push(key);
      }
      view.grid.gridView.set({ selection: _.defaults({ selected: selectedKeys }) });
    }

    this.remove();
  }
}

export class SuggestedBidProductGroupColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n,
    newI18n,
    recommendationType,
    view,
    deps,
    isMCC,
  }) {
    super({
      name: 'SuggestedBid',
      property: 'SuggestedBid',
      title: i18n.getString('Details_View_Suggested_Bid') || '__Suggested bid__',
      bodyClasses: ['grid-column-suggestedBid', 'actionable'],
      colClasses: ['col-shortNumber'],
      editable: true,
      type: 'number',
      enableEdit: item => isSuggestedBidSupported(_.first(item.Opportunities)),
    });
    this.i18n = i18n;
    this.newI18n = newI18n;
    this.currency = this.i18n.currency;
    this.view = view;
    this.deps = deps;
    this.appConfig = deps.appConfig;
    this.jsdata = deps.jsdata;
    this.edmCampaign = edm;
    this.suggestedBidField = 'SuggestedBid';
    this.isMCC = isMCC;
    this.recommendationType = recommendationType;
  }

  get property() {
    return {
      get: _.identity,
      key: 'SuggestedBid',
    };
  }

  template({ value: { Opportunities } }) {
    const {
      i18n, currency, suggestedBidField,
    } = this;
    let bidValue;
    if (isSuggestedBidSupported(_.first(Opportunities))) {
      _.first(Opportunities).SuggestedBid = getFieldValueFromGridData(_.chain(Opportunities).first().result('GridData').value(), 'Bid');
      const suggestedBidValue = _.chain(Opportunities).first().result(suggestedBidField).value();
      bidValue = formatBid(_.chain(Opportunities).first().result('NewProductGroupBid').value() || suggestedBidValue, i18n, currency);
    }
    return template({
      bidValue,
    });
  }

  onPrompt({
    event,
    item,
    newPosition,
  }) {
    if ($(event.target).is('a')) {
      return undefined;
    }

    const key = $(event.target).parents('tr[data-key]').data('key');

    const {
      appConfig,
    } = this;

    const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');

    _.extend(this.deps, {
      config: appConfig,
      decimal: decimalFormatter,
      s$ProductGroup: ProductGroup,
      i18nGlobal,
    });

    const BidAmount = { Bid: { Amount: _.chain(item.Opportunities).first().result('NewProductGroupBid').value() || _.chain(item.Opportunities).first().result('SuggestedBid').value() } };
    const bidEditor = new CustomizedProductGroupsEditBidsView({
      view: this.view,
      deps: this.deps,
      BidAmount,
      IsExcluded: false,
      IsAutoBidding: false,
      selectedItems: [item],
      key,
    });

    const popupEditor = new GridCustomizedPopupEditor({
      editorView: bidEditor.render(),
      cellPosition: newPosition,
      renderBelow: false,
      className: 'grid-popupeditor',
      parentContainerSelector: '.grid-and-disclaim-container',
    });
    popupEditor.render();

    return undefined;
  }
}
